import React, { FC } from 'react';

import classes from 'classnames';
import { prop } from 'ramda';

import { useFileLogoInput } from 'components/shared/FormAdapters/FormDefault/FileLogoInput/functions';
import baseStyles from 'components/shared/FormAdapters/FormDefault/Input/index.module.css';

import Icon from '../../../Icon';
import ArrowUp from '../../../Icon/icons/ArrowUp';
import Modal from '../../../Modal';
import styles from './index.module.css';
import Logo from './Logo';
import { IFileLogoInputProps } from './types';

const FileLogoInput: FC<IFileLogoInputProps> = ({
  size,
  isError,
  disabled,
  value,
  placeholder = 'Choose file...',
  placeholderWhenFilled = 'Replace or Remove File',
  onChange,
}) => {
  const { imgSrc, isModalOpened, handleChange, handleClearFile, handleCloseModal, handleOpenModal } = useFileLogoInput({
    value,
    onChange,
  });

  const inputContainerClasses = classes(
    baseStyles.inputContainer,
    styles.inputContainer,
    size && prop(`inputContainer-${size}`, baseStyles),
    disabled && prop('inputContainer-disabled', baseStyles),
    isError && prop('inputContainer-isError', baseStyles),
  );
  const inputClasses = classes(baseStyles.input, styles.label);

  return (
    <>
      <div className={inputContainerClasses}>
        <label onClick={handleOpenModal} className={inputClasses}>
          <div className={styles.arrowButton}>
            {!value && <Icon component={ArrowUp} width="1.5rem" />}
            {imgSrc && <img src={imgSrc} style={{ maxHeight: '100%' }} alt="logo" />}
          </div>
          <span className={styles.placeholder}>{value ? placeholderWhenFilled : placeholder}</span>
        </label>
      </div>
      {/*@ts-ignore*/}
      <Modal isOpen={isModalOpened} toClose={handleCloseModal}>
        <Logo active={isModalOpened} currentLogo={value} onSave={handleChange} onDelete={handleClearFile} />
      </Modal>
    </>
  );
};

export default FileLogoInput;
